import { Page } from '#components/pages/index/Page';

export default Page;
